import { Box } from '@mui/material';
import { FC } from 'react';

import WarningIcon from '@abg/kit-base/lib/icons/WarningIcon';

import { warningTextStyling } from './WarningText.styling';

export const WarningText: FC<WarningTextProps> = ({ text }) => {
  return (
    <Box sx={warningTextStyling.warningTextWrapper}>
      <WarningIcon sx={warningTextStyling.warningIcon} /> {text}
    </Box>
  );
};

type WarningTextProps = {
  readonly text: string;
};
